export default __webpack_public_path__ + "static/media/Abdullah.77c599d5.jpg";